<template>
  <div class="home">
    <div class="hu">
      <div class="hu_auto">
        <div class="h_a_l">您好，宁波紧固件工业协会欢迎您</div>
        <div class="h_a_r">
          <div class="kh">
            客户服务电话：
          </div>
          <div class="dh">
            {{ phone }}
          </div>
          <router-link to="/about/join?apply=入会申请">
            <div class="sqrh">申请入会</div>
          </router-link>
          <router-link to="/about/onMessage?contactus=在线留言">
            <div class="zxly">在线留言</div>
          </router-link>
        </div>

      </div>
    </div>
    <div class="fex">

      <div class="top">

        <div class="auto">
          <router-link to="/index">
            <div class="left"></div>
          </router-link>

          <div class="right">
            <div class="line" :style="{ left: left + 'rem' }"></div>
            <div class="menu" v-for="(item, index) in menu" :key="index" @click="change(item, index)">
              <div class="font" :class="currPath == item.url ? 'act menuact' : ''">
                {{ item.name }}
              </div>
              <div class="round" v-show="item.show"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-view />
</template>
<script>
import { getPhone } from '@/api/index.js'
import { reactive, toRefs } from "@vue/reactivity";
import { useRouter, useRoute } from "vue-router";
import { computed, onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const data = reactive({
      menu_name: "首页",
      menu: [
        { name: "首页", url: "/home", show: true },
        { name: "最新资讯", url: "/naturals", show: true },
        // { name: "最新资讯", url: "/news", show: true },
        { name: "企业名录", url: "/directory", show: true },
        { name: "行业发展", url: "/earlywar", show: true },
        { name: "协会简介", url: "/association", show: true },
        { name: "外贸预警", url: "/warning/war", show: true },
        { name: "联系我们", url: "/about", show: false },
      ],
      left: 5,
      current: 0,
      name: store.state.name,
      phone: ''
    });

    const currPath = computed(() => {
      return route.matched[0].path;
    });

    function change(item, index) {
      store.dispatch("acname", item.name);
      data.current = index;

      //       console.log(index,'index')
      //       if(index < 2){
      //  data.left=(index +1 ) * 7
      //       }else{
      //       data.left=((index +1 ) * 14)-14
      //       }
      data.menu_name = item.name;
      localStorage.setItem("menu", item.name);
      router.push({
        path: item.url,
      });
    }
    onMounted(() => {
      getPhone({}).then(res => {
    
        data.phone = res.dataList.corp_tel
      })
      data.name = store.state.name;
      data.menu_name = localStorage.getItem("menu");
    });
    return {
      ...toRefs(data),
      change,
      router,
      route,
      store,
      currPath,
    };
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f2f5f9;
  width: 100%;

  background-image: url(./assets/bj.png);
  background-repeat: no-repeat;
  background-size: 100%, 100%;
  // height:90rem;
  background-position: -3rem 35rem;
}

html,
body {
  margin: 0px;
  padding: 0px;
}

.home {
  margin-bottom: 50px;

  .hu {
    height: 32px;

    width: 100%;
    position: fixed;
    top: 0px;
    background: #F2F5F9;
    // background:red;
    z-index: 999;

    .hu_auto {
      margin-left: 26.8rem;
      margin-right: 24.8rem;
      height: 3rem;
      width: 138.4rem;
      display: flex;
      justify-content: space-between;
      // justify-content: center;
      align-items: center;
      overflow: hidden;

      .dh {
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #1890FF;

      }

      .kh {
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #46546E;
      }

      .h_a_l {
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #46546E;
      }

      .h_a_r {
        width: 50%;
        display: flex;
        background: #F2F5F9;
        justify-content: flex-end;

        .sqrh {
          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin-left: 30px;

          &:hover {
            color: #1890FF;
          }
        }

        .zxly {
          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin-left: 30px;

          &:hover {
            color: #1890FF;
          }
        }

      }
    }
  }

  .fex {
    height: 9.2rem;

    .top {
      width: 100%;
      height: 9.2rem;
      background: #ffffff;
      position: fixed;
      top: 30px;
      border-bottom: 1px solid #1890ff;
      z-index: 999;

      .auto {
        margin-left: 26.8rem;

        margin-right: 26.8rem;
        height: 9.2rem;

        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;

        .right {
          display: flex;

          position: relative;


          .menuact {
            border-bottom: 0.4rem solid #1890ff !important;
          }

          .menu {
            font-size: 1.9rem;
            // font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            // font-weight: bold;
            height: 8.5rem;
            margin-top: 3.6rem;
            display: flex;
            align-items: center;
            justify-content: center;

            border-bottom: 0.4rem solid transparent;

            border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
            box-sizing: border-box;

            .round {
              width: 0.4rem;
              height: 0.4rem;
              border-radius: 50%;
              background: #333333;
              opacity: 0.3;
              margin-left: 2.3rem;
              margin-right: 2.3rem;

              &:last-child {}
            }

            .font {
              height: 5.5rem;
              display: flex;
              align-items: center;
              justify-content: center;
              border-bottom: 0.4rem solid transparent;
              cursor: pointer;
            }

            .act {
              color: #1890ff;
            }

          }
        }

        .left {
          height: 6.9rem;
          width: 44.9rem;
          background: url(@/assets/logo.png);
          background-size: 100%, 100%;
          margin-top: 2px;
    background-size: 81%, 81%;
    background-repeat: no-repeat;
        }
      }
    }
  }
}
</style>
